function Spark({ points, color = "var(--acid)" }) {
  return (
    <svg className="spark" width="80" height="22" viewBox="0 0 80 22">
      <polyline points={points} fill="none" stroke={color} strokeWidth="1"/>
    </svg>
  );
}

export default function Kpis({ data }) {
  if (!data) return <div className="kpis"/>;
  const fmt = (n) => n.toLocaleString();
  const fmtMoney = (n) => "£" + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return (
    <div className="kpis">
      <div className="kpi">
        <div className="lbl">Live events</div>
        <div className="val">{data.liveEvents}</div>
        <div className="delta up">▲ 3 vs last 30d</div>
        <Spark points="0,18 10,16 20,14 30,15 40,11 50,12 60,7 70,8 80,4"/>
      </div>
      <div className="kpi">
        <div className="lbl">Tickets sold · 24h</div>
        <div className="val">{fmt(data.ticketsSold24h)}</div>
        <div className="delta up">▲ 18.4% wow</div>
        <Spark points="0,18 10,15 20,17 30,12 40,14 50,9 60,11 70,5 80,7"/>
      </div>
      <div className="kpi">
        <div className="lbl">Gross · this month</div>
        <div className="val">{fmtMoney(data.grossMonth)}</div>
        <div className="delta up">▲ £6,140 vs Apr</div>
        <Spark points="0,16 10,17 20,13 30,14 40,10 50,11 60,8 70,5 80,6"/>
      </div>
      <div className="kpi">
        <div className="lbl">Sell-through</div>
        <div className="val">{data.sellThrough}<span className="unit">%</span></div>
        <div className="delta up">▲ 4 pts</div>
        <Spark points="0,17 10,15 20,16 30,12 40,13 50,11 60,9 70,8 80,6"/>
      </div>
      <div className="kpi">
        <div className="lbl">Refund rate</div>
        <div className="val">{data.refundRate}<span className="unit">%</span></div>
        <div className="delta down">▼ 0.3 pts</div>
        <Spark points="0,5 10,7 20,8 30,9 40,11 50,12 60,14 70,15 80,17" color="var(--ink-3)"/>
      </div>
    </div>
  );
}
